import React, { useState } from 'react';
import { ProcessTransition, ProcessRole } from '../../types/processDefinition';
import { TransitionCard } from './TransitionCard';
import './ProcessArtifactGroup.css';

interface ProcessArtifactGroupProps {
  artifactId: string;
  transitions: ProcessTransition[];
  role: ProcessRole;
  onUpdateTransition: (transitionId: string, transitionData: Record<string, unknown>) => void;
  onDeleteTransition: (transitionId: string) => void;
  onNavigateToProcess: (processId: string) => void;
}

export const ProcessArtifactGroup: React.FC<ProcessArtifactGroupProps> = ({
  artifactId,
  transitions,
  role,
  onUpdateTransition,
  onDeleteTransition,
  onNavigateToProcess,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const getRoleIcon = (role: ProcessRole) => {
    switch (role) {
      case 'PROCESSITEM':
        return '🔄';
      case 'MATERIAL':
        return '📦';
      case 'RESOURCE':
        return '⚙️';
      case 'PROCESSITEM_PERSISTENT':
        return '🔄';
      case 'CREATION':
        return '✨';
      default:
        return '📋';
    }
  };

  const getRoleColor = (role: ProcessRole) => {
    switch (role) {
      case 'PROCESSITEM':
        return '#4CAF50';
      case 'MATERIAL':
        return '#FF9800';
      case 'RESOURCE':
        return '#2196F3';
      case 'PROCESSITEM_PERSISTENT':
        return '#4CAF50';
      case 'CREATION':
        return '#9C27B0';
      default:
        return '#757575';
    }
  };

  return (
    <div className="process-artifact-group">
      <div
        className="artifact-group-header"
        style={{ borderLeftColor: getRoleColor(role) }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="artifact-info">
          <span className="role-icon">{getRoleIcon(role)}</span>
          <span className="artifact-id">{artifactId}</span>
          <span className="transition-count">
            ({transitions.length} transition{transitions.length !== 1 ? 's' : ''})
          </span>
        </div>
        <div className="expand-icon">{isExpanded ? '▼' : '▶'}</div>
      </div>

      {isExpanded && (
        <div className="transitions-container">
          {transitions.map((transition) => (
            <TransitionCard
              key={transition.id}
              transition={transition}
              role={role}
              onUpdate={onUpdateTransition}
              onDelete={onDeleteTransition}
              onNavigateToProcess={onNavigateToProcess}
            />
          ))}
        </div>
      )}
    </div>
  );
};
